// extracted by mini-css-extract-plugin
export default {"addAccountContainer":"AddAccount_addAccountContainer__KMj0L","addIcon":"AddAccount_addIcon__5SYHq","addText":"AddAccount_addText__Cce4K"};